import negociostp from './negociostp';

export default {
  localhost: {},
  negociostp,
};
